// extracted by mini-css-extract-plugin
export default {"Usabilla":"Usabilla_M42fG"};